let folder = 'insights'
export const state = () => ({
  more: false,
  filterLoading: false,
  searchOptionsLoading: false,
  searchOptions: [],
  articlesLoading: true,
  page: 1,
  articles: [],
  sum: 0,
  meta: null,
  stage: null,
  content: null,
  contact: null,
  possibleFilter: {
    primary: [],
    secondary: []
    // type: { text: null, content: [] },
    // audience: { text: null, content: [] },
    // author: { text: null, content: [] },
    // service: { text: null, content: [] },
    // technology: { text: null, content: [] },
    // topic: { text: null, content: [] }
  },
  sort: {
    type: 'asc', // desc || asc
    value: 'datetime'
  },
  filter: {
    primary: [],
    secondary: []
    // type: [],
    // audience: [],
    // author: [],
    // service: [],
    // technology: [],
    // topic: []
  }
})
export const getters = {
  meta(state) {
    return state.meta
  },
  more(state) {
    return state.more
  },
  page(state) {
    return state.page
  },
  stage(state) {
    return state.stage
  },
  articles(state) {
    return state.articles
  },
  sum(state) {
    return state.sum
  },
  content(state) {
    return state.content
  },
  contact(state) {
    return state.contact
  },
  filter(state) {
    return state.filter
  },
  searchOptionsLoading(state) {
    return state.searchOptionsLoading
  },
  searchOptions(state) {
    return state.searchOptions
  },
  possibleFilter(state) {
    return state.possibleFilter
  },
  articlesLoading(state) {
    return state.articlesLoading
  },
  filterLoading(state) {
    return state.filterLoading
  }
}
export const mutations = {
  setMeta(state, { data }) {
    state.meta = data
  },
  setArticles(state, { data }) {
    if (data.length > 0) {
      state.articles = [].concat(state.articles, data)
    } else {
      state.articles = data
    }
    state.articlesLoading = false
  },
  setSum(state, { data }) {
    state.sum = data
  },
  setStage(state, { data }) {
    state.stage = data
  },
  setContent(state, { data }) {
    state.content = data
  },
  setContact(state, { data }) {
    state.contact = data
  },
  setMore(state, { data }) {
    state.more = data
  },
  setPage(state, { data }) {
    state.page = parseInt(data)
  },
  setFilter(state, { data }) {
    state.filter = data
    state.page = 1
  },
  setPossibleFilter(state, { data }) {
    state.possibleFilter = data
    state.filterLoading = false
  },
  setSearchOptions(state, { data }) {
    state.searchOptions = data
    state.searchOptionsLoading = false
  },
  setSearchLoading(state, { data }) {
    state.searchOptionsLoading = data
  },
  setArticlesLoading(state, { data }) {
    state.articlesLoading = data
  },
  setFilterLoading(state, { data }) {
    state.filterLoading = data
  }
}
export const actions = {
  getMeta({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/meta.json`)
      .then((res) => {
        commit('setMeta', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getStage({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/stage.json`)
      .then((res) => {
        commit('setStage', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContent({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/content.json`)
      .then((res) => {
        commit('setContent', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getContact({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/${folder}/contact.json`)
      .then((res) => {
        commit('setContact', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getArticles({ state, commit, rootState }) {
    commit('setArticlesLoading', { data: true })
    return this.$axios
      .get(`/api/insights/articles/${rootState.language}/${state.page}`, {
        params: {
          sort: state.sort,
          filter: state.filter
        }
      })
      .then((res) => {
        let result = {
          articles: [],
          page: 1,
          sum: 0,
          more: false
        }
        if (res.data) {
          result = res.data
        }
        commit('setArticles', { data: result.articles })
        commit('setSum', { data: result.sum })
        commit('setPage', { data: result.page })
        commit('setMore', { data: result.more })
      })
      .catch((err) => {
        commit('setArticles', { data: [] })
        commit('setSum', { data: 0 })
        console.error(err)
      })
  },
  getPossibleFilter({ state, commit, rootState }) {
    commit('setFilterLoading', { data: true })
    return this.$axios
      .get(`/api/insights/possibilities/filter/${rootState.language}`, {
        params: state.filter
      })
      .then((res) => {
        commit('setPossibleFilter', { data: res.data })
      })
      .catch((err) => {
        commit('setPossibleFilter', { data: null })
        console.error(err)
      })
  },
  loadSearchOptions({ commit, rootState }) {
    commit('setSearchLoading', { data: true })
    return this.$axios
      .get(`/api/insights/possibilities/search/options/${rootState.language}`)
      .then((res) => {
        commit('setSearchOptions', { data: res.data })
      })
      .catch((err) => {
        commit('setSearchOptions', { data: null })
        console.error(err)
      })
  },
  getSearchedArticles({ commit, rootState }, { search }) {
    commit('setArticlesLoading', { data: true })
    commit('setArticles', { data: [] })
    return this.$axios
      .get(`/api/insights/articles/${rootState.language}/search/${search}`)
      .then((res) => {
        commit('setArticles', { data: res.data.articles })
        commit('setPage', { data: 1 })
        commit('setMore', { data: false })
        commit('setArticlesLoading', { data: false })
      })
      .catch((err) => {
        commit('setArticles', { data: [] })
        commit('setArticlesLoading', { data: false })
        console.error(err)
      })
  }
}
